var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 51,
    viewBox: "0 0 57 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.10742,
    y: 1.02002,
    width: 42.75,
    height: 40.8,
    rx: 4,
    fill: "#FFD3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7871 30.1922L31.0646 32.7422C31.4921 33.1706 32.4489 33.3744 33.08 33.3744H37.1107C38.3728 33.3744 39.7571 32.4157 40.0828 31.1509L42.6275 23.4192C43.1568 21.93 42.2 20.6653 40.6121 20.6653H36.3778C35.7468 20.6653 35.2175 20.1349 35.3193 19.4005L35.8486 16.014C36.0521 15.0552 35.421 13.9944 34.4643 13.6884C33.6093 13.362 32.5507 13.7904 32.1435 14.4228L27.8075 20.8896",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3926 30.1924V19.8086C22.3926 18.3194 23.0236 17.7891 24.5097 17.7891H25.5683C27.0544 17.7891 27.6854 18.3194 27.6854 19.8086V30.1924C27.6854 31.6816 27.0544 32.212 25.5683 32.212H24.5097C23.0236 32.212 22.3926 31.6816 22.3926 30.1924Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7857 40.5146H43.2386C41.61 40.5146 40.0628 41.147 38.9228 42.2894L35.4418 45.7371C33.8539 47.3079 31.2686 47.3079 29.6807 45.7371L26.1996 42.2894C25.0596 41.147 23.4921 40.5146 21.8839 40.5146H20.3571C16.9779 40.5146 14.25 37.8014 14.25 34.4558V12.1994C14.25 8.85377 16.9779 6.14062 20.3571 6.14062H44.7857C48.165 6.14062 50.8929 8.85377 50.8929 12.1994V34.4558C50.8929 37.781 48.165 40.5146 44.7857 40.5146Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.2a254073c4854d648eba15200e7df203.svg";
export { ForwardRef as ReactComponent };